import {BaseService} from '../baseService.js';

/* 
 * Handles Auto Units
 */
export class AutoUnitService extends BaseService {

	constructor() {	
		super();
	}
	
	async getAutoUnitConfigs() {
		var data = await this.makeGETRequest('/api/resource/auto-units');
		return data;
	}	

	async deleteAutoUnitConfigs(autoUnitId) {
		var data = await this.makeDELETERequest('/api/resource/auto-units/' + autoUnitId);		
		return data;		
	}	
	async saveAutoUnit(autoUnit, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/auto-units/' + autoUnit.autoUnitId, autoUnit);
		} else {
			saved = await this.makePOSTRequest('/api/resource/auto-units', autoUnit);
		}
		return saved;
	}	
	
	async deleteAutoUnit(autoUnitId) {		
		var result = await this.makeDELETERequest('/api/resource/auto-units/' + autoUnitId);		
		return result;
	}
	
	async activateAutoUnit(autoUnitId) {	
		var result = await this.makePUTRequest('/api/resource/auto-units/' + autoUnitId + '/activate');
		return result;
	}	

	async inactivateAutoUnit(autoUnitId) {	
		var result = await this.makePUTRequest('/api/resource/auto-units/' + autoUnitId + '/inactivate');
		return result;
	}	
	
};